import TransportType from '@packages/routing/enums/transportTypes';
import { FeatureConfigAttributesBase } from '../../../server/src/models/featureConfigAttributes/FeatureConfigAttributesBase';
import PackageSize from './Package';

// Feature configuration typing...

export interface FeaturePathMatching {
    value: string;
    matching: 'contains' | 'startsWith' | 'endsWith' | 'exact';
}

export interface FeatureInterfaceBase {
    enabled: boolean;
}
export interface AutoStackingTimeSlot {
    dayOfWeek: number;
    startTime: Date;
    endTime: Date;
    minTimeUntilPickup: number;
    maxTotalTime?: number;
    maxDrivenDistance?: number;
    packageTypeFilter: string;
    pickupAddressFilter: string[];
    maxStackSize?: number;
    transportType?: TransportType;
}

export interface AutoStacking extends FeatureInterfaceBase {
    [key: string]: any;
    maxTotalTime?: number;
    maxDrivenDistance?: number;
    minTimeUntilPickup: number;
    packageTypeFilter: PackageSize[];
    pickupAddressFilter: string[];
    maxStackSize: number;
    transportType?: TransportType;
    timeSlots?: AutoStackingTimeSlot[];
    notificationSlackChannel?: string;
    notificationSlackMessage?: string;
}

export interface Webhook extends FeatureInterfaceBase {
    redirectUrl: string;
    fetchPictureUrl?: boolean;
}

export interface FullEta extends FeatureInterfaceBase {
    errorMargin?: number;
    minimumValue?: number;
    delta?: number;
    shouldCallClosingTool?: boolean;
}
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface PreparationTime extends FeatureInterfaceBase {}

export interface ClosingTool extends FeatureInterfaceBase {
    clientCode: string;
}

export interface Shop {
    address: string;
    enabled: boolean;
    assignment_code: string;
}
export interface E2EFlow extends FeatureInterfaceBase {
    shopList: Shop[];
}

export interface APIForwarder extends FeatureInterfaceBase {
    login: string;
    apiName: string;
    baseUrl: string;
    authUrl?: string;
    password: string;
    clientSecret: string;
    isFlex?: boolean;
    useAddressQualificator?: string;
    slackChannelId?: string;
}

export enum JSONTransformHTTPMethod {
    POST = 'POST',
    GET = 'GET',
    PUT = 'PUT',
    PATCH = 'PATCH',
    DELETE = 'DELETE',
}

export interface JSONTransform extends FeatureInterfaceBase {
    transformFunction: any;
    path?: FeaturePathMatching;
    target?: 'request' | 'response';
    method?: JSONTransformHTTPMethod;
}

// Features...

export enum FEATURES {
    AUTO_STACKING = 'autostacking',
    WEBHOOK = 'webhook',
    API_FORWARDER = 'externalApiForwarder',
    JSON_TRANSFORM = 'jsonTransform',
    FLEETS = 'fleets',
    PRICE_MATRIX = 'priceMatrix',
    QUOTE_DENYING = 'quoteDenying',
    FULL_ETA = 'fullEta',
    PREPARATION_TIME = 'preparationTime',
    CLOSING_TOOL = 'closingTool',
    E2E_FLOW = 'e2eFlow',
}

export interface Feature {
    id: number;
    name: string;
    defaultConfig: any;
    readonly createdAt: Date;
    readonly updatedAt: Date;
}

export interface NewFeature {
    name: string;
    defaultConfig: any;
}

// Client's feature configuration...

export interface ClientFeatureConfig<T extends FeatureInterfaceBase | FeatureConfigAttributesBase> {
    id: number;
    config: T;
    clientId: number;
    featureId: number;
    feature: {
        name: string;
    };
    readonly createdAt: Date;
    readonly updatedAt: Date;
}

export interface NewClientFeatureConfig<T extends FeatureInterfaceBase> {
    clientId: number;
    config: T;
    featureId?: number;
}
